module.exports = __webpack_public_path__ + "img/send-invites-mobile-en.d87c9005.jpg";